import { useTranslation } from "react-i18next";
import { IconUserPlus, IconDownload } from "@tabler/icons-react";

import { useCommunity } from "@contexts/CommunityContext";

import { Button, Text } from "@fragments";

import "./styles.scss";

export default function TableToolbar({ records, loading, communityId, onExport }) {
  const { t } = useTranslation("memberModals");
  const { community } = useCommunity();

  function handleInvite() {
    if (!communityId) return;
    community.triggerShareModal(communityId);
  }

  const label = loading
    ? t("membersList.toolbar.loading")
    : t("membersList.toolbar.records", { count: records });

  return (
    <div className="members-list-toolbar">
      <Text.span contrast={5}>{label}</Text.span>

      <div className="members-list-toolbar__actions">
        <Button
          color="inverse"
          size="small"
          startIcon={<IconUserPlus size={16} stroke={2} />}
          onClick={handleInvite}
          preventLoading
          text={t("membersList.toolbar.invite")}
        />
        <Button
          color="inverse"
          size="small"
          startIcon={<IconDownload size={16} stroke={2} />}
          onClick={onExport}
          disabled={!onExport}
          preventLoading
          text={t("membersList.toolbar.export")}
        />
      </div>
    </div>
  );
}
